import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import eventify from 'Eventify';
import DateFormatted from '../DateFormatted';
import RCore from 'RCore';
const i18Common = require('../../../../i18/i18.Common');
const i18 = RCore.getTranslation.bind({ dict: i18Common });

const Table = styled.div`
    vertical-align: middle;
    border: none;
`;

const MatchCellHeader = styled.div`
    padding: 0;
    font-size: 18px;
    text-align: center;
    color: ${props => props.theme.primaryColor};
`;

const Cell = styled.div`
    position: relative;
    margin: 0;
    white-space: nowrap;
    text-align: center;
    display: flex;
    align-items: center;
    .team-home {
        text-align: right;
        img {
        }
    }
    .team-away {
        text-align: left;
    }
`;

const Team = styled.div`
    width: calc(50% - 60px);
    white-space: nowrap;
    text-align: center;
    font-size: 19px;
    font-weight: normal;
    line-height: 58px;
    color: ${props => props.theme.color};
    & > * {
        vertical-align: middle;
        display: inline-block;
    }

    .logo-box {
        display: inline-block;
        text-align: center;
        padding: 0 10px;
    }
`;

const Score = styled.div`
    width: 120px;
    height: 58px;
    position: relative;
    color: ${props => (props.isLive ? props.theme.primaryTextColor : props.theme.content.accentTextColor)};
    display: flex;
    font-size: 16px;
    line-height: 1.1;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    .top-sub {
        font-size: 21px;
        font-weight: 700;
    }
    .top-sub-score {
        font-size: 32px;
        font-weight: 700;
    }
    .score {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 32px;
        line-height: 34px;
        font-weight: 700;
        flex-grow: 1.2;
    }

    .tv-info {
        width: 100%;
        flex-grow: 1;
        display: flex;
        text-transform: uppercase;
        font-weight: 700;
        align-items: center;
        justify-content: center;
        font-size: 14px;
    }
`;

const IsLiveLabel = styled.div`
    background: ${props => props.theme.primaryColor};
    color: ${props => props.theme.primaryTextColor};
    text-transform: uppercase;
    font-size: 18px;
    font-weight: 700;
    transform: translate(0, -50%) rotate(-90deg);
    position: absolute;
    width: 60px;
    height: 30px;
    line-height: 22px;
    box-sizing: border-box;
    padding: 3px 0 5px;
    left: -15px;
    top: 50%;
    transform-origin: center;
`;

const TeamNameHome = styled.div`
    display: inline-block;
    width: calc(100% - 70px);
    vertical-align: middle;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    text-align: right;
    padding-left: 30px;
    box-sizing: border-box;
`;

const TeamNameAway = TeamNameHome.extend`
    text-align: left;
    padding-right: 30px;
    padding-left: 0;
`;

class MatchCell extends React.Component {
    constructor(props) {
        super(props);
    }

    static contextTypes = {
        info: PropTypes.object,
        screenSizeObserver: PropTypes.object,
        moment: PropTypes.func,
    };

    render() {
        let { event, lang } = this.props;
        event = eventify(event);

        const tvInfo = event.channel && event.channel.name && <div className="tv-info">{event.channel.name}</div>;
        const isToday = this.context.moment(event.startDate).isSame(new Date(), 'day');
        const isFinished = event.isFinished();
        const isComing = event.isComing();
        const isLive = event.isLive();

        return (
            <Cell>
                {isLive && <IsLiveLabel>Live</IsLiveLabel>}
                <Team className="team-home">
                    <TeamNameHome>{event.homeName}</TeamNameHome>
                </Team>
                <Score isLive={isLive}>
                    {isFinished && (
                        <div>
                            <div className="top-sub-score __c__c5_style1">
                                {event.score.home + ' - ' + event.score.away}
                            </div>
                        </div>
                    )}
                    {isLive && (
                        <div>
                            <div className="top-sub-score __c__c5_style1">
                                {event.score.home + ' - ' + event.score.away}
                            </div>
                            {tvInfo}
                        </div>
                    )}
                    {event.isCancelled() && (
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            {i18('status.short.cancelled', lang)}
                        </div>
                    )}
                    {event.isPostponed() && (
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            {i18('status.short.postponed', lang)}
                        </div>
                    )}

                    {isComing &&
                        !event.isCancelled() &&
                        !event.isPostponed() &&
                        (isToday || this.props.timeOnly) && (
                            <div>
                                <DateFormatted
                                    className="top-sub __c__c5_style1"
                                    date={event.startDate}
                                    type="TIME"
                                    el="div"
                                />
                                {tvInfo}
                            </div>
                        )}
                    {isComing &&
                        !event.isCancelled() &&
                        !event.isPostponed() &&
                        !(isToday || this.props.timeOnly) && (
                            <div>
                                <div className="top-sub __c__c5_style1">
                                    <DateFormatted date={event.startDate} type="DATE_SHORT" el="div" />
                                </div>
                                <DateFormatted date={event.startDate} type="TIME" el="div" />
                            </div>
                        )}
                </Score>
                <Team className="team-away">
                    <TeamNameAway>{event.awayName}</TeamNameAway>
                </Team>
            </Cell>
        );
    }
}

MatchCell.propTypes = {
    event: PropTypes.object.isRequired,
};

const Container = ({ children }) => <Table>{children}</Table>;

export default { MatchCellHeader, MatchCell, Container };



/** WEBPACK FOOTER **
 ** ../src/widgets/components/sm/views/matchCell/TextMatchCellCentered.js
 **/